module.exports = __webpack_public_path__ + "static/media/s_purple_2.46e71994.mp3";